export default "<app-tabs-shell>\n\n    About placeholder\n\n</app-tabs-shell>\n";